/* eslint-disable no-unused-vars */
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CampaignSection from 'components/campaign/campaignSection/CampaignSection';
import { showActionsCreative } from 'utils';
import CreativesSectionTabs from 'components/campaign/creativesSection/creativesSectionTabs/CreativesSectionTabs';
import { CampaignSectionAction } from 'components';
import { getActiveCreativesList } from 'store/selectors';

const chosePageCreativesSectionTabs = {
  edit: (props, environment) => (
    <CreativesSectionTabs.EditCampaign {...props} environment={environment} />
  ),
  new_empty: (props, environment) => (
    <CreativesSectionTabs.NewCampaign_empty {...props} environment={environment} />
  ),
  duplicate: (props, environment) => (
    <CreativesSectionTabs.EditCampaign {...props} environment={environment} />
  ),
};

const GeneralCreativeSection = ({ environment, expanded, handleChange }) => {
  const { t } = useTranslation();
  const creativesTracking = useSelector(
    (state) => state?.creatives?.creativeAndTrackingData?.creativesTracking,
  );
  const creativesList = useSelector((state) => state.creatives.creativesList);
  const isCustomTracking = useSelector((state) => state?.tracking?.isCustomTracking);
  const activeCreativesList = useSelector(getActiveCreativesList);

  const showActionsFlag = useMemo(
    () => !showActionsCreative(environment, isCustomTracking, activeCreativesList),
    [isCustomTracking, environment, creativesList, creativesTracking, activeCreativesList],
  );
  const creativesHavingError = useSelector((state) => state?.formErrorsCampaign.creatives);
  const creativesTrackingError = useSelector(
    (state) => state?.formErrorsCampaign.creativesConversionTracking,
  );

  return (
    <CampaignSection
      expanded={expanded === 'creatives'}
      discription='*Atleast One of Creatives Must Be Active , Icon and Image for All Active Creatives Is Mandatory.'
      error={creativesHavingError || creativesTrackingError}
      isExpandable={true}
      handleChange={handleChange('creatives')}
      title={t('campaign.creatives.title')}
      details={componentToRender(environment, expanded)()}
      showActions={showActionsFlag}
      actions={
        <CampaignSectionAction
          onClick={handleChange('conversionTracking')}
          title='Go to Conversion Tracking'
          expanded={expanded === 'creatives'}
          hidden={!showActionsFlag}
        />
      }
    />
  );
};

export default memo(GeneralCreativeSection);

const componentToRender = (environment, expanded) => {
  const ComponentToRender = chosePageCreativesSectionTabs[environment];
  if (environment === 'new_empty') {
    return expanded === 'creatives' ? () => ComponentToRender({}, environment) : () => null;
  }
  return () => ComponentToRender({}, environment);
};
